import { Itinerary } from './itineray.model';
import { ActivatedRouteSnapshot } from "@angular/router";
import { CartService } from "./cart.service";
import { Cart } from "./cart.model";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { first } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class CartResolverService implements Resolve<Cart> {
  constructor(private cartService: CartService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<Cart> {
    const itinerary: Itinerary = route.parent.data.itinerary;

    return this.cartService.get(itinerary.cart.id).pipe(first());
  }
}
